'use client';

import React from 'react';
import { CustomButton } from '@/components/ui/CustomButton';
import { FormRadioGroup } from '@/components/ui/FormRadioGroup';
import { useFcaLookup } from './hooks/useFcaLookup';
import { FCALookupSection } from './components/FCALookupSection';
import { CompanyDetailsForm } from './components/CompanyDetailsForm';
import { ManualCompanyDetailsForm } from './components/ManualCompanyDetailsForm';
import { NetworkSelectionForm } from './components/NetworkSelectionForm';

const fcaDataOptions = ['Yes', 'No'];
const councilMemberOptions = ['Yes', 'No'];

export const Step2Form = ({ formData, handleInputChange, handleSelectChange, handleSubmitClick, errors }) => {
  const { lookupState, handleFcaLookup, handleFcaReset, handleFcaIdChange } = useFcaLookup(formData, handleSelectChange);
  const handleFcaDataChange = (selectedValue) => {
    const mappedValue = selectedValue === 'Yes' ? '1' : '0';
    const event = { target: { name: 'fcaData', value: mappedValue } };
    handleInputChange(event);

    // Clear manual fields when selecting "Yes"
    if (mappedValue === '1') {
      handleSelectChange('name2')('');
      handleSelectChange('phone2')('');
      handleSelectChange('al12')('');
      handleSelectChange('al22')('');
      handleSelectChange('town2')('');
      handleSelectChange('county2')('');
      handleSelectChange('postcode2')('');
    }
  };

  const handleCouncilMemberChange = (selectedValue) => {
    const mappedValue = selectedValue === 'Yes' ? '1' : '0';
    const event = { target: { name: 'councilMember', value: mappedValue } };
    handleInputChange(event);
  };

  return (
    <>
      <h1 className="text-[#373945] text-4xl font-semibold mb-6 text-left lg:text-center lg:mb-12">
        Company information
      </h1>

      <p className="text-[#5B5D6B] text-base font-450 mb-12 lg:hidden">
        <span className="font-bold">Step 2:</span> We need a few details about your company to get your new account set up.
      </p>

      <FCALookupSection
        formData={formData}
        handleInputChange={handleInputChange}
        handleFcaIdChange={handleFcaIdChange}
        lookupState={lookupState}
        handleFcaLookup={handleFcaLookup}
        errors={errors}
      />

      <CompanyDetailsForm
        formData={formData}
        handleInputChange={handleInputChange}
        lookupState={lookupState}
        handleFcaReset={handleFcaReset}
      />

      <div className="mb-6">
        <p className="text-[#373945] text-base font-medium mb-2">
          Are your details correct?
        </p>
        <p className="text-[#373945] text-sm mb-2">
          If you&apos;re not based at the same postcode as your firm, please select &apos;no&apos; and manually fill in your address
        </p>
        <FormRadioGroup
          name="fcaData"
          label=""
          value={formData.fcaData === '1' ? 'Yes' : formData.fcaData === '0' ? 'No' : ''}
          onChange={handleFcaDataChange}
          options={fcaDataOptions}
          isVertical={false}
        />
      </div>

      <ManualCompanyDetailsForm
        formData={formData}
        handleInputChange={handleInputChange}
        errors={errors}
      />

      <div className="mb-6">
        <p className="text-[#373945] text-base font-medium mb-2">
          Is your firm an Equity Release Council Member?
        </p>
        <FormRadioGroup
          name="councilMember"
          label=""
          value={formData.councilMember === '1' ? 'Yes' : formData.councilMember === '0' ? 'No' : ''}
          onChange={handleCouncilMemberChange}
          options={councilMemberOptions}
          isVertical={false}
          error={errors.councilMember}
        />
      </div>

      <NetworkSelectionForm
        formData={formData}
        handleSelectChange={handleSelectChange}
        errors={errors}
      />

      <CustomButton
        variant="primaryLarge"
        type="button"
        className="disabled:opacity-50 disabled:cursor-not-allowed w-full md:w-3/4 md:mx-auto mb-12"
        onClick={handleSubmitClick}
      >
        Next step
      </CustomButton>
    </>
  );
};
